export default "__VITE_ASSET__CS1d7PoX__"